import { ActionSubject } from "../action";
import { Id, Ref, RelativeChartPosition, Room, RoomTimer, User } from "shared";

export const roomAction = {
	setCurrentRoom: new ActionSubject<Room | null>(),
	setCurrentRoomToFirstInList: new ActionSubject<Room | null>(),
	joinRoom: new ActionSubject<Room>(),
	removeUserFromRoom: new ActionSubject<Ref<User>, Ref<Room>>(),
	list: new ActionSubject<Room[]>(),
	create: new ActionSubject<Room>(),
	update: new ActionSubject<Room>(),
	remove: new ActionSubject<Ref<Room>>(),
	leaveRoom: new ActionSubject<Ref<Room>>(),
	get: new ActionSubject<Room>(),
	updateTimer: new ActionSubject<RoomTimer | null, Ref<Room>>(),
	updateUserPosition: new ActionSubject<RelativeChartPosition | null, Ref<Room>>(),
	followUserId: new ActionSubject<Id<User> | null, Ref<Room>>(),
	forceFollow: new ActionSubject<Ref<Room>>()
};
